import { useState, useCallback } from 'react';
import { Button, ButtonProps, Menu, MenuItem } from '@mui/material';
import { makeStyles } from '../../themes';
import { ArrowDropDownIcon } from '../../assets';

export interface SaveOption {
  value: string;
  label: string;
}

export interface SaveActionButtonProps {
  options: Array<SaveOption>;
  onSelect: (value: any) => any;
  buttonText?: string;
  buttonProps?: Omit<ButtonProps, 'endIcon' | 'onClick'>;
}

export function OptionsButton({
  options,
  onSelect,
  buttonText = 'Save',
  buttonProps,
}: SaveActionButtonProps) {
  const { classes, cx } = useStyles();
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const { className, ...restButtonProps } = buttonProps || {};

  const handleClick = useCallback((event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  }, []);

  const handleClose = useCallback(() => {
    setAnchorEl(null);
  }, []);

  const handleSelect = useCallback(
    (value: string) => {
      handleClose();
      onSelect(value);
    },
    [onSelect, handleClose],
  );

  return (
    <div>
      <Button
        onClick={handleClick}
        className={cx(classes.btn, className)}
        endIcon={<ArrowDropDownIcon />}
        {...restButtonProps}
      >
        {buttonText}
      </Button>
      <Menu anchorEl={anchorEl} open={open} onClose={handleClose}>
        {options.map((option) => (
          <MenuItem
            key={option.value}
            onClick={() => handleSelect(option.value)}
          >
            {option.label}
          </MenuItem>
        ))}
      </Menu>
    </div>
  );
}

const useStyles = makeStyles({ name: { SaveActionButton: OptionsButton } })(
  (theme) => ({
    btn: {
      flexDirection: 'row',
    },
  }),
);
